import { ViewInArOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useClientStorage } from 'customHooks/useClientStorage'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useBomItemLengthUnit } from 'features/measurementSystem/utils/useBomItemUnitOfMeasure'
import { isEqual } from 'lodash'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useEffect, useState } from 'react'
import { useAppSelector } from 'store/configureStore'
import { ModelController } from '../manager/ModelController'

export const BoundingBoxTool = (props: {
  bomItemPointer: BomItemPointer
  controller: ModelController
}) => {
  const dimensions = useAppSelector(
    projectSelectors.bomItemDimensionsSelector(props.bomItemPointer),
    isEqual,
  )

  const bomItemLengthUnit = useBomItemLengthUnit(props.bomItemPointer)

  const [active, setActive] = useClientStorage('boundingBoxToolActive', true)

  const [modelLoaded, setModelLoaded] = useState(false)

  useEffect(() => {
    if (dimensions.boundingBox3dPoints?.length) {
      props.controller.onFileLoaded(async () => {
        setModelLoaded(true)
        if (active) {
          await props.controller.AddBoundingBox(
            dimensions.boundingBox3dPoints,
            bomItemLengthUnit,
          )
          props.controller.FitAll()
        }
      })
    }
  }, [
    active,
    bomItemLengthUnit,
    dimensions.boundingBox3dPoints,
    props.controller,
  ])

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    if (active) {
      props.controller.ClearBoundingBox()
      setActive(false)
    } else {
      setActive(true)
    }
  }

  if (!dimensions.boundingBox3dPoints?.length) {
    return null
  }

  return (
    <Tooltip
      title={
        <LocalizedTypography translationKey="project:viewer-bounding-box" />
      }
    >
      <IconButton
        size="small"
        onClick={handleClick}
        color="inherit"
        sx={{
          backgroundColor: active ? 'primary.main' : 'transparent',
          color: active ? 'white' : 'inherit',
          '&:hover': {
            backgroundColor: active ? 'primary.main' : 'transparent',
            color: active ? 'white' : 'inherit',
          },
        }}
      >
        <ViewInArOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
